<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <factor-tree-query ref="factor-tree" :factor-tree="filterFactors" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch
          :default-unit-prop.sync="unitProp"
          @change="onUnitPropChange"
        />

        <dimension-type :default-dimension-type.sync="dimension" @change="onDimensionChanged" />
      </template>

      <trend-related-chart-wrapper
        :data-list="dataList"
        :unit-prop="unitProp"
        :download-name="downloadName"
        :factors="filterFactors"
        show-list
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import FactorTreeQuery from '../../../../components/Data/Query/FactorTreeQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import DisplayType from '../../../../components/Data/DisplayType'
import TrendRelatedChartWrapper from '../../../../components/Data/TrendRelatedChartWrapper'

export default {
  name: 'SiteCompareNormal',
  routeInfo: {
    label: '常规4+2',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, FactorTreeQuery, CompletedQuery, DataWrapper, UnitSwitch, DisplayType, TrendRelatedChartWrapper},
  data () {
    return {
      query: {
        isMultipleIntegral: true
      }
    }
  },
  computed: {
    isSetAllFactorIds: () => 1,
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false)
      ]
    },
    minSiteSelectNumber: () => 2,
    downloadName: () => '站点对比常规因子'
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    },
    onDimensionChanged () {
      this.formatData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/05Site-Compare/00Normal/index.vue